export const AppRoute = {
  Unauthorized: {
    name: 'unauthorized',
    path: '/unauthorized',
  },
  Login: {
    name: 'login',
    path: '/login',
  },
  Dashboard: {
    name: 'dashboard',
    path: '/',
  },
  Settings: {
    name: 'settings',
    path: '/settings',
  },
  Statistic: {
    name: 'statistic',
    path: '/statistic',
  },
  Process: {
    name: 'process',
    path: '/process',
    Detail: {
      name: 'process-detail',
      path: '/process/:id',
      Main: {
        name: 'process-detail-main',
        path: '/process/:id/main',
      },
      Versions: {
        name: 'process-detail-versions',
        path: '/process/:id/versions',
      },
      Instances: {
        name: 'process-detail-instances',
        path: '/process/:id/instances',
      },
      Stats: {
        name: 'process-detail-stats',
        path: '/process/:id/stats',
      },
      Access: {
        name: 'process-detail-access',
        path: '/process/:id/access',
      },
    },
    Edit: {
      name: 'process-edit',
      path: '/process/:id/edit',
    },
  },
  ProcessInstance: {
    name: 'process-instance',
    path: '/process-instance',
    Page: {
      name: 'instance-page',
      path: '/process-instance/:id',
      Main: {
        name: 'instance-page-main',
        path: '/process-instance/:id/main',
      },
      Process: {
        name: 'instance-page-process',
        path: '/process-instance/:id/process',
      },
      Task: {
        name: 'instance-page-task',
        path: '/process-instance/:id/task',
      },
      SubInstances: {
        name: 'instance-page-sub-instances',
        path: '/process-instance/:id/sub-instances',
      },
    },
  },
  ProcessTask: {
    name: 'process-task',
    path: '/process-task',
    Page: {
      name: 'process-task-page',
      path: '/process-task/:id',
      Main: {
        name: 'process-task-page-main',
        path: '/process-task/:id/main',
      },
      Process: {
        name: 'process-task-page-process',
        path: '/process-task/:id/process',
      },
    },
  },
} as const
